import { httpClient } from '@/lib/api/client';
import { ENDPOINTS } from '@/lib/api/endpoints';
import type { ID } from '@/types/common';

export interface AppNotification {
  id: ID;
  type: string;
  title: string;
  message: string;
  roles: string[];
  custodianId?: number | null;
  refType?: string;
  refId?: number;
  read: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface NotificationList {
  data: AppNotification[];
  unread: number;
}

export interface NotificationRepository {
  list(): Promise<NotificationList>;
  markRead(id: ID): Promise<{ message: string }>;
  markAllRead(): Promise<{ message: string }>;
}

export const notificationRepository: NotificationRepository = {
  list: () => httpClient.get<NotificationList>(ENDPOINTS.notifications.list),
  markRead: (id) => httpClient.post<{ message: string }>(ENDPOINTS.notifications.markRead(id)),
  markAllRead: () => httpClient.post<{ message: string }>(ENDPOINTS.notifications.markAllRead),
};
